<template>
  <div id="reviews">
    <div class="grid-container-reviews">
      <div v-for="review in this.reviews" class="review-container box">
        <ReviewHeader :review="review"></ReviewHeader>
        <div class="experience-appreciation-container">
          <div class="experience-author">
            <ProfileMenu :user="review.user"></ProfileMenu>
          </div>
          <div class="experience-appreciation">
            <div
                v-if="review.rating !== null"
                class="appreciation-wrapper"
            >
              <div class="appreciation">
                {{ review.rating }}
              </div>
              <font-awesome-icon icon="star"/>
            </div>
            <div
                v-if="review.appreciation.positiveAmount !== null && review.platform !== 'Booking' && review.platform !== 'Tripadvisor'"
                class="appreciation-wrapper"
            >
              <div class="appreciation">
                {{ review.appreciation.positiveAmount }}
              </div>
              <font-awesome-icon icon="thumbs-up"/>
            </div>
            <div
                v-if="review.appreciation.negativeAmount !== null && review.platform !== 'Booking' && review.platform !== 'Tripadvisor'"
                class="appreciation-wrapper"
            >
              <div class="appreciation">
                {{ review.appreciation.negativeAmount }}
              </div>
              <font-awesome-icon icon="thumbs-down"/>
            </div>
            <div
                v-if="review.appreciation.sharedAmount !== null && review.platform !== 'Booking' && review.platform !== 'Tripadvisor'"
                class="appreciation-wrapper"
            >
              <div class="appreciation">
                {{ review.appreciation.sharedAmount }}
              </div>
              <font-awesome-icon icon="share"/>
            </div>
          </div>
        </div>
        <div class="experience selectable" id="experience-scroll">
          {{ review.text }}
        </div>
        <div class="experience-targetwords">
          <div v-for="targetword in review.targetWords">
            {{ targetword.value }}
          </div>
        </div>
        <div class="experience-footer">
          <div>{{ review.date }}</div>
          <div class="review-platform-link-wrapper">
            <div class="review-platform">{{ review.platform }}</div>
            <font-awesome-icon
                icon="link"
                class="experience-link"
                v-on:click="navigateToReviewSource(review.url)"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ReviewHeader from "@/components/ReviewHeader.vue";
import ProfileMenu from "@/components/ProfileMenu.vue";

import {central_api_domain} from "@/constants/endpoints";

export default {
  name: "Reviews",
  props: {
    reviews: "",
    rendered: false,
  },
  components: {
    ReviewHeader,
    ProfileMenu,
  },
  methods: {
    showAuthorProfile(id) {
      let popup = document.getElementById(id);
      popup.classList.toggle("show");
    },
    showExperience(text, target_words) {
      let experiencePopup = document.getElementById("experiencePopup");
      let experienceText = document.getElementById("experience-expanded-text");
      experienceText.textContent = text;
      experiencePopup.style["display"] = "block";

      for (let i = 0; i < target_words.length; i++) {
        this.highlight(target_words[i].value);
      }
    },
    hideExperience() {
      let experiencePopup = document.getElementById("experiencePopup");
      experiencePopup.style["display"] = "none";
    },
    highlightTargetWords() {
      let inputText = document.getElementsByClassName("experience");
      let targetWords = [];

      if (this.reviews) {
        for (let i = 0; i < this.reviews.length; i++) {
          for (let j = 0; j < this.reviews[i].targetWords.length; j++) {
            if (!targetWords.includes(this.reviews[i].targetWords[j].value)) {
              targetWords.push(" " + this.reviews[i].targetWords[j].value);
            }
          }
        }
        for (let i = 0; i < inputText.length; i++) {
          let innerHTML = '';
          if (this.reviews[i].title !== null && (this.reviews[i].title !== '')) {
            innerHTML = this.reviews[i].title + '<br /><br />' + this.reviews[i].text;
          } else {
            innerHTML = this.reviews[i].text;
          }

          for (let j = 0; j < targetWords.length; j++) {
            let targetword = targetWords[j];

            if (innerHTML.includes(targetword)) {
              let index = innerHTML.indexOf(targetword);

              if (index >= 0) {
                innerHTML =
                    innerHTML.substring(0, index) +
                    "<span class='highlight'>" +
                    innerHTML.substring(index, index + targetword.length) +
                    "</span>" +
                    innerHTML.substring(index + targetword.length);
                inputText[i].innerHTML = innerHTML;
              }
            }
          }
        }
      }
    },
    setPolarity(polarity, review) {
      review.polarity = polarity;
      review.graded = 1;
      this.ratePost(review);
    },
    navigateToReviewSource(url) {
      window.open(url);
    },
    updateParent() {
      this.$parent.getCompany();
    },
    ratePost(review) {
      const url = central_api_domain + "posts/rate";

      let body = {
        postId: review.id,
        polarity: review.polarity
      }

      let fetchData = {
        method: "PUT",
        body: JSON.stringify(body),
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      };

      fetch(url, fetchData)
          .then((res) => res.json())
          .then((result) => {
            this.updateParent();
          });

    },
    updatePost(review) {
      const url = central_api_domain + "posts";
      let fetchData = {
        method: "PUT",
        body: JSON.stringify(review),
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      };
      fetch(url, fetchData)
          .then((res) => res.json())
          .then((result) => {
            this.updateParent();
          });
    },
  },
  updated() {
    this.highlightTargetWords();
  },
  mounted() {
    this.highlightTargetWords();
  },
};
</script>
